module.exports = __webpack_public_path__ + "img/icon_utill_alram.2f7955ce.svg";